import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';

export const InputSection = styled(Box)`
  padding-top: 10px;

  .inputMember {
    width: 100%;
  }
`;

export const Content = styled(Box)`
  display: flex;
  flex-direction: column;
  padding: 25px 20px;
  height: 100%;

  .btn-save-guest {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 6px 10px;

    width: 70px;
    height: 36px;

    background: rgba(0, 0, 0, 0.12);
    border-radius: 4px;
  }

  form {
    height: 100%;
  }
`;

export const Section = styled(Box)`
  padding-top: 25px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 20px;
  height: 100%;
`;

export const SectionHeaderDrawer = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #bdbdbd;
  padding: 0px 0px 16px;
  position: relative;
`;

export const Title = styled(Typography)`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 23px;
  line-height: 29px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #000000;
`;
